@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/custom-suggestions-option' as *;
@use '../@shared/custom-suggestions-options-group' as *;
@use '../@shared/custom-suggestions-toggle' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/input.mixin' as *;
@use '../@shared/mixins' as *;
@use '../@shared/button.mixin' as *;
@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-alert;

	@include kol-custom-suggestions-option;
	@include kol-custom-suggestions-options-group;
	@include kol-custom-suggestions-toggle;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
	@include kol-icon-styles();

	.kol-combobox {
		&__delete {
			@include kol-button-styles('kol-button');
		}
	}

	.kol-custom-suggestions-toggle {
		&:not(&--disabled) {
			cursor: pointer;
		}

		&--disabled {
			opacity: 0.5;
		}
	}
}
